export const RoutesUrl = {
  // common routes
  Signup: "/signup",
  Home: "/",
  Support: "/support",
  Article: "/articles",
  Videos: "/videos",
  Resouces: "/resources",
  Etotp: "/external-totp",
  ResoucesSearch: "/resources/:search",
  TermsAndConditions: "/terms-conditions",

  //  Login Urls for vendor
  VendorLogin: "/vendor/login",
  VendorForgetPassword: "/vendor/forgot-password",
  VendorSetPassword: "/vendor/set-password",

  // Login Url for client
  ClientLogin: "/login",
  LoginHelp: "/login/help",
  ClientForgotLoginId: "/login/forgot-loginid",
  ClientForgotPassword: "/login/forgot-password",
  ClientUnblockAccount: "/login/unblock-account",
  ClientForgotYOB: "/login/forgot-yob",

  // Client Urls
  MyApps: "/my-apps",

  // Vendor urls
  VendorDashboard: "/vendor/dashboard",
  VendorMyApps: "/vendor/my-apps",
  VendorReqACall: "/vendor/request-a-call",
  VendorSignup: "/vendor-signup",
};
